import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "../entries.css";
import { FaTimes } from "react-icons/fa";

const PalletSelectionModal = ({ idExpAuditor, master, onClose }) => {
  const [isClosing, setIsClosing] = useState(false); // para animacion cuando se cierre el modal
  const [pallets, setPallets] = useState([]);
  const [selectedPalletId, setSelectedPalletId] = useState("");
  const [pieces, setPieces] = useState("");
  const [rows, setRows] = useState([]);

  const [formData, setFormData] = useState({
    grossWeight: "",
    grossVolume: "",
    realWeight: "",
    realVolume: "",
  });

  const [errors, setErrors] = useState({
    grossWeight: false,
    grossVolume: false,
    realWeight: false,
    realVolume: false,
  });

  const handleClose = () => {
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300); // mismo tiempo que la animación (0.3s)
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
    setErrors((prev) => ({ ...prev, [id]: false })); // Limpiar error al escribir
  };

  const handleAccept = async () => {
    if (rows.length === 0) {
      Swal.fire("Sin filas", "Agrega al menos una tarima.", "warning");
      return;
    }

    try {
      const idExpAuditor =
        master?.resp?.id_exp_auditor ||
        master?.id_exp_auditor ||
        master?.id ||
        null;

      if (!idExpAuditor) {
        return Swal.fire(
          "Error",
          "No se encontró el ID de auditoría.",
          "error",
        );
      }

      const payload = {
        id_exp_auditor: idExpAuditor,
        id: rows.map((r) => r.palletTypeId),
        pieces: rows.map((r) => r.pieces),
      };

      const url = `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/cubiscan/savePallets`;

      const res = await axios.post(url, payload, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Tarimas guardadas",
        text: "Las tarimas fueron registradas correctamente.",
      });

      handleClose();
      window.location.reload();
    } catch (error) {
      console.error("❌ Error savePallets:", error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          "No se pudieron guardar las tarimas.",
      });
    }
  };

  const handleAddRow = () => {
    if (!pieces || pieces <= 0) {
      Swal.fire("Campos requeridos", "Ingresa el número de piezas", "warning");
      return;
    }

    const selectedPallet = pallets.find(
      (p) => p.id === parseInt(selectedPalletId),
    );

    // fallback cuando no hay select
    const palletName = selectedPallet?.name ?? "Tarima genérica";
    const weight = Number(selectedPallet?.weight ?? 1); // peso default
    const qty = parseInt(pieces);

    const newRow = {
      id: Date.now(),
      palletTypeId: selectedPallet?.id ?? null,
      palletType: palletName,
      weight,
      pieces: qty,
      totalWeight: weight * qty,
    };

    setRows((prev) => [...prev, newRow]);
    setSelectedPalletId("");
    setPieces("");
  };

  // const handleAccept = () => {
  //     const newErrors = {
  //         grossWeight: !formData.grossWeight,
  //         grossVolume: !formData.grossVolume,
  //         realWeight: !formData.realWeight,
  //         realVolume: !formData.realVolume,
  //     };

  //     setErrors(newErrors);

  //     const hasErrors = Object.values(newErrors).some(Boolean);
  //     if (!hasErrors) {
  //         console.log("Todo válido, enviando datos...", formData);
  //         // lógica para enviar los datos
  //     } else {
  //         console.log("Hay errores en el formulario.");
  //     }
  // };

  // const handleAddRow = () => {
  //   // if (!selectedPalletId || !pieces) {
  //   //   Swal.fire(
  //   //     "Campos requeridos",
  //   //     "Selecciona un tipo de tarima y/o número de piezas",
  //   //     "warning"
  //   //   );
  //   //   return;
  //   // }

  //   if (!pieces || pieces <= 0) {
  //     Swal.fire("Campos requeridos", "Ingresa el número de piezas", "warning");
  //     return;
  //   }

  //   const selectedPallet = pallets.find(
  //     (p) => p.id === parseInt(selectedPalletId)
  //   );
  //   if (!selectedPallet) return;

  //   const peso = selectedPallet.weight ?? 1; // Ajusta si tienes un campo real de peso
  //   const totalWeight = peso * parseInt(pieces);

  //   const newRow = {
  //     id: Date.now(),
  //     palletTypeId: selectedPallet.id,
  //     palletType: selectedPallet.name,
  //     weight: peso,
  //     pieces: parseInt(pieces),
  //     totalWeight,
  //   };

  //   setRows((prev) => [...prev, newRow]);
  //   setSelectedPalletId("");
  //   setPieces("");
  // };

  const handleDeleteRow = (id) => {
    setRows((prev) => prev.filter((row) => row.id !== id));
  };

  // const getPalletsByGuide = async () => {
  //   try {
  //     const idExpAuditor =
  //       master?.resp?.id_exp_auditor || master?.id_exp_auditor || master?.id;

  //     if (!idExpAuditor) return;

  //     const res = await axios.post(
  //       `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/cubiscan/getPallets`,
  //       { id_exp_auditor: idExpAuditor },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (res.data?.code === 1) {
  //       const mappedRows = (res.data.data || []).map((p) => ({
  //         id: p.id,
  //         palletTypeId: p.id,
  //         palletType: p.name,
  //         weight: Number(p.weight),
  //         pieces: Number(p.pieces),
  //         totalWeight: Number(p.total_weight),
  //       }));

  //       console.log("Tarimas WS:", res.data.data);

  //       setRows(mappedRows); // ← aquí puede ser []
  //     }
  //   } catch (error) {
  //     console.error("❌ Error getPalletsByGuide:", error);
  //   }
  // };

  const getPalletsByGuide = async () => {
    try {
      if (!idExpAuditor) {
        console.warn("⚠️ idExpAuditor no recibido");
        return;
      }

      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND_EXPO}/api/v1/exp_entries/cubiscan/getPallets`,
        { id_exp_auditor: idExpAuditor },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        },
      );

      if (res.data?.code === 1) {
        setRows(
          (res.data.data || []).map((p) => ({
            id: p.id,
            palletTypeId: p.id,
            palletType: p.name,
            weight: Number(p.weight),
            pieces: Number(p.pieces),
            totalWeight: Number(p.total_weight),
          })),
        );
      }
    } catch (error) {
      console.error("❌ Error getPalletsByGuide:", error);
    }
  };

  useEffect(() => {
    getPalletsByGuide();
  }, [idExpAuditor]);

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 1050,
      }}
    >
      {/* Fondo oscuro */}
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1040,
        }}
      />
      <div
        className={`modal-dialog modal-lg ${
          isClosing ? "modal-slide-up" : "modal-slide-down"
        }`}
        style={{
          position: "relative",
          zIndex: 1060,
          margin: "5vh auto",
        }}
      >
        <div className="modal-content">
          <div
            className="modal-header"
            style={{
              backgroundColor: "#020C41",
              color: "white",
              padding: "0.5rem 1rem",
            }}
          >
            <h5 className="modal-title m-0">Selección de Tarimas</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={handleClose}
            ></button>
          </div>

          <div className="modal-body container-fluid">
            <table className="table mt-4">
              <thead className="text-center">
                <tr>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Tipo de Tarima
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Peso
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Piezas
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Peso Total
                  </th>
                  <th style={{ backgroundColor: "#020C41", color: "white" }}>
                    Acciones
                  </th>
                </tr>
              </thead>
              {/* <tbody className='text-center'>
                                <tr>
                                    <td>{pallets?.[1]?.name ?? 'Cargando...'}</td>
                                    <td>
                                        
                                    </td>
                                    <td>
                                        
                                    </td>
                                    <td>
                                        
                                    </td>
                                    <td>
                                        <button onClick={() => alert('Cerrar')} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                            <FaTimes size={20} style={{ color: '#020C41' }} />
                                        </button>
                                    </td>
                                </tr>
                            </tbody> */}

              {/* <tbody className="text-center">
                {rows.map((row) => (
                  <tr key={row.id}>
                    <td>{row.palletType}</td>
                    <td>{row.weight}</td>
                    <td>{row.pieces}</td>
                    <td>{row.totalWeight}</td>
                    <td>
                      <button
                        onClick={() => handleDeleteRow(row.id)}
                        style={{
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        <FaTimes size={20} style={{ color: "#020C41" }} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody> */}

              <tbody className="text-center">
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan="5">
                      No hay tarimas registradas para esta guía
                    </td>
                  </tr>
                ) : (
                  rows.map((row) => (
                    <tr key={row.id}>
                      <td>{row.palletType}</td>
                      <td>{row.weight}</td>
                      <td>{row.pieces}</td>
                      <td>{row.totalWeight}</td>
                      <td>
                        <button
                          onClick={() => handleDeleteRow(row.id)}
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          <FaTimes size={20} style={{ color: "#020C41" }} />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            <div className="row">
              <div className="col-5">
                <label for="palletType" className="amc-label">
                  Tipo de Tarima
                </label>
                <select
                  id="palletType"
                  className="form-select"
                  value={selectedPalletId}
                  onChange={(e) => setSelectedPalletId(e.target.value)}
                >
                  <option value="">Seleccione una tarima</option>
                  {pallets.map((pallet) => (
                    <option key={pallet.id} value={pallet.id}>
                      {pallet.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-4">
                <label for="pieces" class="amc-label">
                  Piezas
                </label>
                <input
                  type="number"
                  class="form-control"
                  id="pieces"
                  value={pieces}
                  onChange={(e) => setPieces(e.target.value)}
                />
              </div>
              <div className="col-3 text-end justify-content-end align-self-end">
                <button className="btnn" onClick={handleAddRow}>
                  Agregar fila
                </button>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col mt-2 d-flex justify-content-end gap-2">
                <button className="btnn" onClick={handleClose}>
                  Cancelar
                </button>
                <button className="btnn" onClick={handleAccept}>
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PalletSelectionModal;
